angular.module('bmsApp.sm.job')
	.controller('SMAvailabilityModalCtrl',
		[
			'$state',
			'$scope',
			'$timeout',
			'$modalInstance',
			'EmployeeOptionsSvc',
			'job',
			'jobDurationMins',
			'jobLicense',
			'jobPostcode',
			function ($state,
					  $scope,
					  $timeout,
					  $modalInstance,
					  EmployeeOptionsSvc,
					  job,
					  jobDurationMins,
					  jobLicense,
					  jobPostcode) {

				function init() {
					self.loading = true;
					self.job = job;
					self.jobDurationMins = jobDurationMins;
					self.jobLicense = jobLicense;
					self.jobPostcode = jobPostcode;
					// EmployeeOptionsSvc.employee()
					// 	.then(function (response) {
					// 		self.form.options.employee = response.data.options;
					// 		self.loading = false;
					// 	});
					self.loading = false;
				}

				function close() {
					$modalInstance.dismiss('cancel');
				}

				function onEmployeeStartTimeClicked(employee, dateTime, available) {
					if (!available) {
						return;
					}
					$modalInstance.close({
						employee: employee,
						dateTime: dateTime
					});
				}

				var self = $scope.SMAvailabilityModalCtrl = {
					loading: false,
					job: undefined,
					employees: [],
					form: {
						options: {}
					},
					methods: {
						init: init,
						close: close,
						onEmployeeStartTimeClicked: onEmployeeStartTimeClicked
					}
				};

			}
		]);
